

































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import DataTable from '../../components/DataTable.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { MathUtils } from '@/util/mathUtils';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';
import { ToastEvent } from '@/types/event';
import { EventBus } from '../../main';

// tslint:disable-next-line: no-var-requires
const PendingInvoicesDateTable = require('../../datatable/PendingInvoicesDateTable.json');
@Component({
    components: {
        DataTable,
    },
})
export default class PayInvoiceModal extends Vue {
    private show = false;
    private pendingInvoicesDateTable = PendingInvoicesDateTable;
    private totalAmount: string = '';

    private mounted() {
        this.show = true;
        this.getPendingInvoice();
    }

    private async getPendingInvoice() {
        const response = await ObjectFactory.getInvoiceService().getPendingInvoice(this.$store.state.serverUrl);
        this.pendingInvoicesDateTable.data = undefined;
        this.totalAmount = '';
        if (response.success && response.data && response.data.length > 0) {
            let totalAmount = 0;
            response.data.forEach((element) => {
                totalAmount += element.dueAmount;
                element.dueAmount = MathUtils.formatCurrency(element.dueAmount);
                element.dueDate = DateUtils.formatDate(element.dueDate, DateUtils.FORMAT_DATETIME_MONTH);
            });
            this.totalAmount = MathUtils.formatCurrency(totalAmount);
        }
        this.pendingInvoicesDateTable.data = response.data;
    }

    private async payInvoice() {
        const response = await ObjectFactory.getInvoiceService().payInvoice(this.$store.state.serverUrl);
        this.pendingInvoicesDateTable.data = undefined;
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_INVOICE_PAID'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$router.push({ name: MedTransGoConstants.VIEW_INVOICE_PANEL_NAME });
    }

}
